// Updated ParticipantForm to use modal popup and consistent layout
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import stylesDefault from '../default.module.css';
import stylesSpec from './participantForm.module.css';
import { shirt } from '../../../../config/meta-informationen';
import { showErrorToast, showInfoToast } from '../../../../code/ToastHelper';
import { Icons } from '../../../../code/IconHandler';
export default function ParticipantForm({ participant, camp_id, onClose, onSave }) {
    const [formData, setFormData] = useState({
        campID: camp_id ? camp_id : '',
        vornameKind: '',
        nachnameKind: '',
        birthdate: '',
        mitglied: false,
        email: '',
        shirt: '',
        vornameErziehung: '',
        nachnameErziehung: '',
        telefon: '',
        street: '',
        housenumber: '',
        zusatz: '',
        plz: '',
        area: '',
        eatingHabit: '',
        allergies: '',
        sickness: '',
        bemerkung: ''
    });
    console.log("Camp_id: ", camp_id);
    useEffect(() => {
        if (participant) {
            setFormData({
                campID: participant.camp_id,
                titleCamp: participant.titleCamp,
                vornameKind: participant.vornameKind,
                nachnameKind: participant.nachnameKind,
                birthdate: participant.birthdate?.slice(0, 10) || '',
                mitglied: participant.mitglied,
                email: participant.email,
                shirt: participant.shirt,
                vornameErziehung: participant.vornameErziehung,
                nachnameErziehung: participant.nachnameErziehung,
                telefon: participant.telefon,
                street: participant.street,
                housenumber: participant.housenumber,
                zusatz: participant.zusatz,
                plz: participant.plz,
                area: participant.area,
                eatingHabit: participant.eatingHabit,
                allergies: participant.allergies,
                sickness: participant.sickness,
                bemerkung: participant.bemerkung
            });
        }
    }, [participant]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = async (e) => {
        console.log(formData)
        e.preventDefault();
        try {
            if (participant?.id) {
                await axios.put(`/api/participant/${participant.id}`, formData);
                showInfoToast(`Teilnehmer: ${participant.vornameKind} ${participant.nachnameKind} wurde geupdated!`);
            } else {
                console.log(formData)
                await axios.post('/api/participant', formData);
                showInfoToast(`Teilnehmer: ${formData.vornameKind} ${formData.nachnameKind} wurde hinzugefügt!`);
            }
            if (onSave) onSave();
            if (onClose) onClose();
        } catch (error) {
            console.error('Fehler beim Speichern des Teilnehmers:', error);
            showErrorToast("Ein Fehler beim Speichern ist aufgetreten.");
        }
    };

    return (
        <div className={stylesDefault.modalOverlay}>
            <div className={stylesDefault.modalForm}>
                <Icons.X className={stylesSpec.xbutton} onClick={onClose} />
                <h2>{participant ? 'Teilnehmer bearbeiten' : 'Neuen Teilnehmer anlegen'}</h2>
                <form onSubmit={handleSubmit} className={stylesDefault.form}>
                    <label>Vorname Kind:<input type="text" name="vornameKind" value={formData.vornameKind} onChange={handleChange} required /></label>
                    <label>Nachname Kind:<input type="text" name="nachnameKind" value={formData.nachnameKind} onChange={handleChange} required /></label>
                    <label>Geburtstag:<input type="date" name="birthdate" value={formData.birthdate} onChange={handleChange} required /></label>
                    <label><span>Mitglied:</span><input type="checkbox" name="mitglied" checked={formData.mitglied} onChange={handleChange} /></label>
                    <label>E-Mail:<input type="email" name="email" value={formData.email} onChange={handleChange} required /></label>
                    <label>T-Shirt Größe:
                        <select name="shirt" value={formData.shirt} onChange={handleChange} required>
                            <option value="" disabled>Wähle die passende Größe...</option>
                            {Object.keys(shirt).map((key) => (<option key={key} value={key}>{shirt[key]}</option>))}
                        </select>
                    </label>
                    <label>Vorname Erziehungsperson:<input type="text" name="vornameErziehung" value={formData.vornameErziehung} onChange={handleChange} /></label>
                    <label>Nachname Erziehungsperson:<input type="text" name="nachnameErziehung" value={formData.nachnameErziehung} onChange={handleChange} /></label>
                    <label>Telefon:<input type="text" name="telefon" value={formData.telefon} onChange={handleChange} /></label>
                    <label>Straße:<input type="text" name="street" value={formData.street} onChange={handleChange} /></label>
                    <label>Hausnummer:<input type="text" name="housenumber" value={formData.housenumber} onChange={handleChange} /></label>
                    <label>Zusatz:<input type="text" name="zusatz" value={formData.zusatz} onChange={handleChange} /></label>
                    <label>PLZ:<input type="text" name="plz" value={formData.plz} onChange={handleChange} /></label>
                    <label>Ort:<input type="text" name="area" value={formData.area} onChange={handleChange} /></label>
                    <div className={stylesSpec.textarea}>
                        <label>Essgewohnheiten:</label>
                        <textarea name="eatingHabit" value={formData.eatingHabit} onChange={handleChange} />
                    </div>
                    <div className={stylesSpec.textarea}>
                        <label>Allergien:</label>
                        <textarea name="allergies" value={formData.allergies} onChange={handleChange} />
                    </div>
                    <div className={stylesSpec.textarea}>
                        <label>Krankheiten:</label>
                        <textarea name="sickness" value={formData.sickness} onChange={handleChange} />
                    </div>
                    <div className={stylesSpec.textarea}>
                        <label>Bemerkung:</label>
                        <textarea name="bemerkung" value={formData.bemerkung} onChange={handleChange} />
                    </div>
                    <div className={stylesSpec.actions}>
                        <button type="submit" className={stylesDefault.greenButton}>Speichern</button>
                        <button type="button" className={stylesDefault.redButton} onClick={onClose}>Abbrechen</button>
                    </div>
                </form>
            </div>
        </div>
    );
}